import { SelectSheetOption } from "../../../components/MobileForm/types";
import { SchedulerRunOutcome } from "../../../services";
import { labelOfStatus } from "../utils/status";

export const OUTCOME_LABELS: Record<SchedulerRunOutcome, string> = {
  SUCCESS: "Success",
  FAILURE: "Failure",
};

export const FILTER_OPTIONS: SelectSheetOption[] = [
  { value: "all", label: "All statuses" },
  ...(["critical", "warning", "unknown", "healthy"] as const).map((status) => ({
    value: status,
    label: labelOfStatus(status),
  })),
];
